export default __webpack_public_path__ + "static/media/male_2.02177572.png";